import { render, staticRenderFns } from "./OzlRowCheckBox.vue?vue&type=template&id=e83423a8"
import script from "./OzlRowCheckBox.vue?vue&type=script&lang=js"
export * from "./OzlRowCheckBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports